import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collegeService, companyService, coordinatorService, studentService, placementDriveService, vacancyService, applicationService } from '../../services/api';
import './AdminDashboardHome.css';

function AdminDashboardHome() {
  const [stats, setStats] = useState({
    colleges: 0,
    companies: 0,
    coordinators: 0,
    students: 0,
    placementDrives: 0,
    vacancies: 0,
    applications: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const [colleges, companies, coordinators, students, drives, vacancies, apps] = await Promise.all([
        collegeService.getColleges(),
        companyService.getCompanies(),
        coordinatorService.getCoordinators(),
        studentService.getStudents(),
        placementDriveService.getPlacementDrives(),
        vacancyService.getVacancies(),
        applicationService.getApplications()
      ]);
      setStats({
        colleges: (colleges || []).length,
        companies: (companies || []).length,
        coordinators: (coordinators || []).length,
        students: (students || []).length,
        placementDrives: (drives || []).length,
        vacancies: (vacancies || []).length,
        applications: (apps || []).length
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-dashboard-home">
        <div className="dashboard-welcome"><h1>Admin Dashboard</h1><p>Loading...</p></div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-home">
      <div className="dashboard-welcome">
        <h1>Welcome to Admin Dashboard</h1>
        <p>Manage countries, states, districts, universities, colleges, coordinators, students, companies, placement drives, vacancies, and applications.</p>
      </div>

      <div className="stats-grid">
        <Link to="/admin/colleges" className="stat-card">
          <span className="stat-icon">🏫</span>
          <span className="stat-value">{stats.colleges}</span>
          <span className="stat-label">Colleges</span>
        </Link>
        <Link to="/admin/companies" className="stat-card">
          <span className="stat-icon">🏢</span>
          <span className="stat-value">{stats.companies}</span>
          <span className="stat-label">Companies</span>
        </Link>
        <Link to="/admin/coordinators" className="stat-card">
          <span className="stat-icon">👤</span>
          <span className="stat-value">{stats.coordinators}</span>
          <span className="stat-label">Coordinators</span>
        </Link>
        <Link to="/admin/student" className="stat-card">
          <span className="stat-icon">🎓</span>
          <span className="stat-value">{stats.students}</span>
          <span className="stat-label">Students</span>
        </Link>
        <Link to="/admin/placement-drives" className="stat-card">
          <span className="stat-icon">📋</span>
          <span className="stat-value">{stats.placementDrives}</span>
          <span className="stat-label">Placement Drives</span>
        </Link>
        <Link to="/admin/vacancies" className="stat-card">
          <span className="stat-icon">💼</span>
          <span className="stat-value">{stats.vacancies}</span>
          <span className="stat-label">Vacancies</span>
        </Link>
        <Link to="/admin/applications" className="stat-card">
          <span className="stat-icon">📄</span>
          <span className="stat-value">{stats.applications}</span>
          <span className="stat-label">Applications</span>
        </Link>
      </div>

      <div className="quick-links">
        <h3>Quick Links</h3>
        <div className="links-grid">
          <Link to="/admin/country">Manage Countries</Link>
          <Link to="/admin/state">Manage States</Link>
          <Link to="/admin/district">Manage Districts</Link>
          <Link to="/admin/university">Manage Universities</Link>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboardHome;
